import { render, staticRenderFns } from "./NewTransactionContratacionForm.vue?vue&type=template&id=0d552127&scoped=true"
import script from "./NewTransactionContratacionForm.vue?vue&type=script&lang=js"
export * from "./NewTransactionContratacionForm.vue?vue&type=script&lang=js"
import style0 from "./NewTransactionContratacionForm.vue?vue&type=style&index=0&id=0d552127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d552127",
  null
  
)

export default component.exports